<template>
    <v-card outlined class="cyan accent-4 white--text">
        <div class="cyan darken-2 pa-4">
            <div class="subtitle-1 font-weight-medium">
                <span>The 3 main concepts</span>
            </div>
        </div>

        <v-card-text class="pa-6 pb-7 white--text" v-if="loaded">
            <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-start">
                    <div class="title mr-2">1.</div>
                    <div>
                        <div class="title font-weight-regular">My Feelings</div>
                        <div class="caption mt-n1" style="opacity:.8">(3 concepts)</div>
                    </div>
                </div>

                <div class="d-flex align-center">
                    <v-icon class="mr-5" :class="(concepts && concepts.feeling) ? 'white--text' : 'cyan--text text--darken-2'">fa-check</v-icon>
                    <v-btn outlined class="white--text" @click="$emit('edit', 'feeling')">Edit</v-btn>
                </div>
            </div>

            <v-divider class="mt-4 mb-3"></v-divider>

            <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-start">
                    <div class="title mr-2">2.</div>
                    <div>
                        <div class="title font-weight-regular">My Interests</div>
                        <div class="caption mt-n1" style="opacity:.8">(3 concepts)</div>
                    </div>
                </div>

                <div class="d-flex align-center">
                    <v-icon class="mr-5" :class="(concepts && concepts.interestedIn) ? 'white--text' : 'cyan--text text--darken-2'">fa-check</v-icon>
                    <v-btn outlined class="white--text" @click="$emit('edit', 'interestedIn')">Edit</v-btn>
                </div>
            </div>

            <v-divider class="mt-4 mb-3"></v-divider>

            <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-start">
                    <div class="title mr-2">3.</div>
                    <div>
                        <div class="title font-weight-regular">My Strengths</div>
                        <div class="caption mt-n1" style="opacity:.8">(3 concepts)</div>
                    </div>
                </div>

                <div class="d-flex align-center">
                    <v-icon class="mr-5" :class="(concepts && concepts.goodAt) ? 'white--text' : 'cyan--text text--darken-2'">fa-check</v-icon>
                    <v-btn outlined class="white--text" @click="$emit('edit', 'goodAt')">Edit</v-btn>
                </div>
            </div>

            <v-divider class="mt-6"></v-divider>

            <div class="mt-6 text-center">
                <v-btn class="white cyan--text text--darken-3" @click="$emit('prev')">
                    <v-icon small left color="cyan darken-3">fa-angle-left</v-icon>
                    Back to Attributes
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        model: {}
    }),
    props: ['concepts'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.model = JSON.parse(JSON.stringify(this.concepts));
            this.loaded = true;
        }
    }
}
</script>